var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { select, Store } from '@ngrx/store';
import { DELETE_CONTACT_TAG, DELETE_DATA, GET_DATA, GET_EVENTS, GET_FILTER_BY_TAGS, GET_FILTER_CALL_LENGTHS, GET_FILTER_EVENT_TYPES, GET_FILTER_MY_NUMBERS, GET_FILTER_USERS, GetColumnsSuccessAction, GetContactsFailureAction, GetContactsSuccessAction, GetDataFailureAction, GetEventsFailureAction, GetEventsSuccessAction, GetFilterItemsFailureAction, GetFilterItemsSuccessAction, GetRawColumnsSuccessAction, SET_TAGS_FOR_SELECTED } from './contacts.actions';
import { ContactsService } from './shared/services/contacts.service';
import { TranslateService } from '@ngx-translate/core';
import { getEventsOptionSelector, getMassiveActionSelector, getTempPageSelector } from './contacts.reducer';
var ContactsEffects = /** @class */ (function () {
    function ContactsEffects(actions$, contactsService, translate, store) {
        var _this = this;
        this.actions$ = actions$;
        this.contactsService = contactsService;
        this.translate = translate;
        this.store = store;
        this.getData = this.actions$.pipe(ofType(GET_DATA), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getEventsOptionSelector))), switchMap(function (_a) {
            var payload = _a[0], eventsOption = _a[1];
            if (payload.page.filter.users && !payload.page.filter.users.length) {
                delete payload.page.filter.users;
            }
            var potentialFilter = __assign({}, payload.page.filter, { contactId: null });
            var filtersModePagination = __assign({}, payload.page.pagination, { offset: payload.offset });
            var potentialPage = eventsOption
                ? __assign({}, payload.page, { filter: potentialFilter }) : __assign({}, payload.page, { pagination: filtersModePagination });
            var columnDetails = {
                translation: null,
                name: 'DETAILS',
                type: 'NATIVE',
                key: 'NATIVE_DETAILS'
            };
            var columnAgent = {
                translation: null,
                name: 'AGENT',
                type: 'NATIVE',
                key: 'NATIVE_AGENT'
            };
            return _this.contactsService.getOptionalData(eventsOption, potentialPage).pipe(switchMap(function (response) {
                var filteredColumns;
                var integrationUser;
                var rawColumns = response.columns;
                response.columns = response.columns.find(function (item) { return item.key === 'NATIVE_DETAILS'; })
                    ? response.columns
                    : response.columns.concat([columnDetails]);
                response.columns = response.columns.find(function (item) { return item.key === 'NATIVE_AGENT'; })
                    ? response.columns
                    : response.columns.concat([columnAgent]);
                if (!eventsOption) {
                    filteredColumns = response.columns.filter(function (col) {
                        return col.key !== 'NATIVE_EVENT_TYPE' &&
                            col.key !== 'NATIVE_EVENT_STATUS_INFO' &&
                            col.key !== 'NATIVE_NAME' &&
                            col.key !== 'NATIVE_SURNAME' &&
                            col.key !== 'NATIVE_EMAIL' &&
                            col.key !== 'NATIVE_CREATOR_LOGIN' &&
                            col.key !== 'NATIVE_AGENT_PHONE_NUMBER';
                    });
                }
                else {
                    filteredColumns = response.columns.filter(function (col) {
                        return col.key !== 'NATIVE_NAME' &&
                            col.key !== 'NATIVE_EVENT_STATUS_INFO' &&
                            col.key !== 'NATIVE_SURNAME' &&
                            col.key !== 'NATIVE_EMAIL' &&
                            col.key !== 'NATIVE_CREATOR_LOGIN' &&
                            col.key !== 'NATIVE_AGENT_PHONE_NUMBER' &&
                            col.key !== 'NATIVE_TAGS';
                    });
                }
                var columnsOpaqued = _this.contactsService.opaqueColumns(filteredColumns);
                var rawColumnsOpaqued = _this.contactsService.opaqueColumns(rawColumns);
                var anonymousLabel;
                _this.translate.get('UNKNOWN').subscribe(function (resp) {
                    anonymousLabel = resp;
                });
                _this.translate.get('CONTACTS_LIST.INTEGRATION_USER').subscribe(function (resp) {
                    integrationUser = resp;
                });
                response.items.data.map(function (item) {
                    var name = item['NATIVE_NAME'] ? item['NATIVE_NAME'] : anonymousLabel;
                    var surname = item['NATIVE_SURNAME'] ? item['NATIVE_SURNAME'] : '';
                    var email = item['NATIVE_EMAIL'] ? item['NATIVE_EMAIL'] : '';
                    var agentLogin = item['NATIVE_CREATOR_LOGIN'] ? item['NATIVE_CREATOR_LOGIN'] : '';
                    var agentNumber = item['NATIVE_AGENT_PHONE_NUMBER'] ? item['NATIVE_AGENT_PHONE_NUMBER'] : null;
                    item.NATIVE_AGENT = {
                        agentLogin: agentLogin === 'integration_user' ? integrationUser : agentLogin,
                        agentNumber: agentNumber
                    };
                    item.NATIVE_DETAILS = {
                        name: name + " " + surname,
                        email: email
                    };
                    return item;
                });
                return [
                    new GetColumnsSuccessAction({ dataCol: columnsOpaqued, page: potentialPage }),
                    new GetContactsSuccessAction({ data: response, page: potentialPage }),
                    new GetRawColumnsSuccessAction(rawColumnsOpaqued)
                ];
            }), catchError(function (error) { return of(new GetContactsFailureAction(error)); }));
        }));
        this.deleteData = this.actions$.pipe(ofType(DELETE_DATA), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getEventsOptionSelector)), this.store.pipe(select(getTempPageSelector)), this.store.pipe(select(getMassiveActionSelector))), switchMap(function (_a) {
            var payload = _a[0], eventsOption = _a[1], currentPage = _a[2], massAction = _a[3];
            if (currentPage) {
                delete currentPage.filter.contactId;
            }
            if (massAction && payload.include && !payload.include.length) {
                delete payload.include;
            }
            else if (!massAction && payload.exclude && !payload.exclude.length) {
                delete payload.exclude;
            }
            if (!eventsOption) {
                var params = massAction ? __assign({ filter: currentPage.filter }, payload) : payload;
                return _this.contactsService.deleteContacts(params).pipe(map(function (response) {
                    _this.contactsService.fetchDataAction(currentPage);
                }), catchError(function (error) { return of(new GetDataFailureAction(error)); }));
            }
        }));
        this.setTagsForSelected = this.actions$.pipe(ofType(SET_TAGS_FOR_SELECTED), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getEventsOptionSelector)), this.store.pipe(select(getTempPageSelector)), this.store.pipe(select(getMassiveActionSelector))), switchMap(function (_a) {
            var payload = _a[0], eventsOption = _a[1], currentPage = _a[2], massAction = _a[3];
            if (massAction && payload.include && !payload.include.length) {
                delete payload.include;
            }
            else if (!massAction && payload.exclude && !payload.exclude.length) {
                delete payload.exclude;
            }
            if (!eventsOption) {
                var params = massAction ? __assign({ filter: currentPage.filter }, payload) : payload;
                return _this.contactsService.setTagsForSelected(params).pipe(map(function (response) {
                    return _this.contactsService.fetchDataAction(currentPage);
                }), catchError(function (error) { return of(new GetDataFailureAction(error)); }));
            }
        }));
        this.deleteContactTag = this.actions$.pipe(ofType(DELETE_CONTACT_TAG), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getEventsOptionSelector)), this.store.pipe(select(getTempPageSelector))), switchMap(function (_a) {
            var payload = _a[0], eventsOption = _a[1], currentPage = _a[2];
            if (!eventsOption) {
                return _this.contactsService.removeTagsForSelected(payload).pipe(map(function (response) {
                    return _this.contactsService.fetchDataAction(currentPage);
                }), catchError(function (error) { return of(new GetDataFailureAction(error)); }));
            }
        }));
        this.getEvents = this.actions$.pipe(ofType(GET_EVENTS), map(function (action) { return action.payload; }), switchMap(function (payload) {
            var eventsPayload = payload;
            eventsPayload.pagination.offset = 0;
            return _this.contactsService.getDetails(eventsPayload).pipe(map(function (response) {
                if (payload.filter.contactId) {
                    var expandedResponseItems = response.items.data.map(function (el) {
                        return __assign({}, el, { recordId: eventsPayload.filter.contactId });
                    });
                    var newItems = __assign({}, response.items, { data: expandedResponseItems });
                    var events = __assign({}, response, { items: newItems });
                    return new GetEventsSuccessAction(events);
                }
            }), catchError(function (error) { return of(new GetEventsFailureAction(error)); }));
        }));
        this.getUsers = this.actions$.pipe(ofType(GET_FILTER_USERS), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getTempPageSelector))), switchMap(function (_a) {
            var payload = _a[0], selectedTempItems = _a[1];
            return _this.contactsService.getUsers().pipe(map(function (response) {
                var usersList;
                if (selectedTempItems &&
                    selectedTempItems.filter &&
                    selectedTempItems.filter[payload] &&
                    selectedTempItems.filter[payload].length) {
                    var selectedItemsNames_1 = selectedTempItems.filter[payload];
                    usersList = response.map(function (user) {
                        if (selectedItemsNames_1.includes(user.username)) {
                            return {
                                name: user.username,
                                type: 'users',
                                isFilter: true
                            };
                        }
                        else {
                            return {
                                name: user.username,
                                type: 'users',
                                isFilter: false
                            };
                        }
                    });
                }
                else {
                    usersList = response.map(function (user) { return ({ name: user.username, type: 'users', isFilter: false }); });
                }
                return new GetFilterItemsSuccessAction({ list: usersList, filterName: 'users' });
            }), catchError(function (error) { return of(new GetFilterItemsFailureAction(error)); }));
        }));
        this.getMyPhoneNumbers = this.actions$.pipe(ofType(GET_FILTER_MY_NUMBERS), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getTempPageSelector))), switchMap(function (_a) {
            var payload = _a[0], selectedTempItems = _a[1];
            return _this.contactsService.getPhoneNumbers().pipe(map(function (response) {
                var numbersList;
                if (selectedTempItems &&
                    selectedTempItems.filter &&
                    selectedTempItems.filter[payload] &&
                    selectedTempItems.filter[payload].length) {
                    var selectedItemsNames_2 = selectedTempItems.filter[payload];
                    numbersList = response.map(function (number) { return ({
                        name: number.msisdn,
                        type: 'callerIds',
                        label: number.label,
                        isFilter: selectedItemsNames_2.includes(number.msisdn),
                        countryCode: number.isoCountry
                    }); });
                }
                else {
                    numbersList = response.map(function (number) { return ({
                        name: number.msisdn,
                        label: number.label,
                        type: 'callerIds',
                        countryCode: number.isoCountry,
                        isFilter: false
                    }); });
                }
                return new GetFilterItemsSuccessAction({ list: numbersList, filterName: 'callerIds' });
            }), catchError(function (error) { return of(new GetFilterItemsFailureAction(error)); }));
        }));
        this.getEventTypes = this.actions$.pipe(ofType(GET_FILTER_EVENT_TYPES), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getTempPageSelector))), switchMap(function (_a) {
            var payload = _a[0], selectedTempItems = _a[1];
            return _this.contactsService.getEventsTypes().pipe(map(function (response) {
                var eventTypesList;
                if (selectedTempItems &&
                    selectedTempItems.filter &&
                    selectedTempItems.filter[payload] &&
                    selectedTempItems.filter[payload].length) {
                    var selectedItemsNames_3 = selectedTempItems.filter[payload];
                    eventTypesList = response.map(function (eventType) {
                        if (selectedItemsNames_3.includes(eventType)) {
                            return {
                                name: eventType,
                                type: 'eventTypes',
                                isFilter: true
                            };
                        }
                        else {
                            return {
                                name: eventType,
                                type: 'eventTypes',
                                isFilter: false
                            };
                        }
                    });
                }
                else {
                    eventTypesList = response.map(function (eventType) { return ({ name: eventType, type: 'eventTypes', isFilter: false }); });
                }
                var translatedFilteredItems = eventTypesList.map(function (item) {
                    _this.translate.get("CONTACTS_LIST.STATUS." + item.name).subscribe(function (resp) {
                        item = __assign({}, item, { translatedTitle: resp });
                    });
                    return item;
                });
                var sortedEventTypes = translatedFilteredItems.sort(function (a, b) {
                    return a.translatedTitle.localeCompare(b.translatedTitle, _this.translate.currentLang);
                });
                return new GetFilterItemsSuccessAction({ list: sortedEventTypes, filterName: 'eventTypes' });
            }), catchError(function (error) { return of(new GetFilterItemsFailureAction(error)); }));
        }));
        this.getFilterByTags = this.actions$.pipe(ofType(GET_FILTER_BY_TAGS), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getTempPageSelector))), switchMap(function (_a) {
            var payload = _a[0], selectedTempItems = _a[1];
            return _this.contactsService.getFilterByTags().pipe(map(function (response) {
                var usedTagsList;
                if (selectedTempItems &&
                    selectedTempItems.filter &&
                    selectedTempItems.filter[payload] &&
                    selectedTempItems.filter[payload].length) {
                    var selectedItemsNames_4 = selectedTempItems.filter[payload];
                    usedTagsList = response.map(function (tag) {
                        if (selectedItemsNames_4.includes(tag)) {
                            return {
                                name: tag,
                                type: 'tags',
                                isFilter: true
                            };
                        }
                        else {
                            return {
                                name: tag,
                                type: 'tags',
                                isFilter: false
                            };
                        }
                    });
                }
                else {
                    usedTagsList = response.map(function (tag) { return ({ name: tag, type: 'tags', isFilter: false }); });
                }
                var sortedTagsList = usedTagsList.sort(function (a, b) {
                    return a.name.localeCompare(b.name, _this.translate.currentLang);
                });
                return new GetFilterItemsSuccessAction({ list: sortedTagsList, filterName: 'tags' });
            }), catchError(function (error) { return of(new GetFilterItemsFailureAction(error)); }));
        }));
        this.getCallLenghts = this.actions$.pipe(ofType(GET_FILTER_CALL_LENGTHS), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getTempPageSelector))), map(function (_a) {
            var payload = _a[0], selectedTempPageItems = _a[1];
            var rangeItemsList;
            if (selectedTempPageItems &&
                selectedTempPageItems.filter &&
                selectedTempPageItems.filter[payload] &&
                selectedTempPageItems.filter[payload].length) {
                var selectedItemsRanges = selectedTempPageItems.filter[payload];
                rangeItemsList = selectedItemsRanges.map(function (rangeItem, index) {
                    return {
                        name: rangeItem.name,
                        type: 'callLengths',
                        isFilter: true,
                        range: rangeItem
                    };
                });
            }
            else {
                rangeItemsList = [
                    {
                        name: 'RANGE_1',
                        range: {
                            name: 'RANGE_1',
                            minLengthSeconds: 0,
                            maxLengthSeconds: 3599
                        },
                        type: 'callLengths',
                        isFilter: false
                    }
                ];
            }
            return new GetFilterItemsSuccessAction({ list: rangeItemsList, filterName: payload });
        }), catchError(function (error) { return of(new GetFilterItemsFailureAction(error)); }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "getData", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "deleteData", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "setTagsForSelected", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "deleteContactTag", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "getEvents", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "getUsers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "getMyPhoneNumbers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "getEventTypes", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "getFilterByTags", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ContactsEffects.prototype, "getCallLenghts", void 0);
    return ContactsEffects;
}());
export { ContactsEffects };
